<template>
  <div class="headers">
    <div class="title">亿佰特工单管理系统</div>
    <!-- <div class="log"><img :src="headimgurl" alt=""></div> -->
    <!-- <div class="name">{{ name }}</div> -->
    <div class="name">
      <el-dropdown @command="outLogin" trigger="click">
        <span class="el-dropdown-link">
          {{ name }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item  command="out">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderComponet',
  data(){
    return{
      headimgurl:localStorage.getItem('headimgurl'),
      name:localStorage.getItem('name')
    }
  },
  methods:{
    outLogin(command){
      if(command === 'out'){
        localStorage.setItem('menu','')
        localStorage.setItem('user_token','')
        this.$router.replace({name:'Login'})
      }
    }
  }
}
</script>


<style scoped lang="scss">
.headers{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .title{
    font-size: 24px;
    font-weight: 600;
    color: #fff;
  }
  .name{
    font-size: 14px;
    color: #fff;
  }

  .log{
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #fff;
    img{
      width: 100%;
      border-radius: 50%;
    }
  }
}

.el-dropdown-link{
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}
</style>
